import {BrowserRouter, Route, Routes} from "react-router-dom";
import Main from "./components/layout/Main";
import HomeContent from "./pages/home/HomeContent";
import NotFound from "./pages/info/not-found/NotFound";
import Profile from "./pages/profile/Profile";
import ExchangeCreate from "./pages/exchange/v1/ExchangeCreate";
import ExchangeMy from "./components/exchange/v1/ExchangeMy";
import AllRatesContent from "./pages/curses/AllRatesContent";
import AppAuthBootstrap from "./components/auth/AppAuthBootstrap";
import UnderConstructionGate from "./components/layout/UnderConstructionGate";
import ExchangeFlow from "./pages/exchange/v1/ExchangeFlow";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppAuthBootstrap>
          <Routes>
            <Route path="/" element={<Main/>}>
              <Route index element={<HomeContent/>}/>
              <Route path="all-curses" element={<AllRatesContent/>}/>
              <Route path="profile" element={<Profile/>}/>
              <Route path="exchange/my" element={<UnderConstructionGate/>}/>
              {/*<Route path="exchange/my" element={<ExchangeMy/>}/>*/}
              {/*<Route path="exchange/create" element={<ExchangeCreate/>}/>*/}
              <Route path="exchange/create" element={<UnderConstructionGate/>}/>
              {/*<Route path="exchange/flow/:txId" element={<ExchangeFlow/>}/>*/}
              <Route path="exchange/flow/:txId" element={<UnderConstructionGate/>}/>
              <Route path="usd-amount" element={<UnderConstructionGate/>}/>
              <Route path="*" element={<NotFound/>}/>
            </Route>
          </Routes>
        </AppAuthBootstrap>
      </BrowserRouter>
    </div>
  )
    ;
}

export default App;
